export function hmsToSecondsOnly(hms: string): number | null {
    const a = hms.split(':'); // split it at the colons

    if (a.length < 3) return null;

    if (Number(a[1]) >= 60 || Number(a[2]) >= 60) return null;

    const seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    return seconds;
}


export function secondToHHMMSS(second: number): string {
   return new Date(second * 1000).toISOString().substr(11, 8);
}
